import { render, staticRenderFns } from "./pageOne.vue?vue&type=template&id=4570a76a&scoped=true&"
import script from "./pageOne.vue?vue&type=script&lang=js&"
export * from "./pageOne.vue?vue&type=script&lang=js&"
import style0 from "./pageOne.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../../statistics/css/addProject.css?vue&type=style&index=1&id=4570a76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570a76a",
  null
  
)

export default component.exports